import { useContext, useEffect } from 'react';
import { AuthContext } from '../../context/Auth/AuthContext';
import { CreditUserContext } from '../../context/CreditUser/CreditUserContext';
import { mergeSentryUser } from '../../configs/sentry';

// Observa el estado de Auth/CreditUser desde afuera y lo refleja en Sentry,
// sin que esos providers necesiten saber que GlitchTip existe.
const SentryUserSync = () => {
  const { mail } = useContext(AuthContext);
  const { creditUser } = useContext(CreditUserContext);

  useEffect(() => {
    if (mail) mergeSentryUser({ email: mail });
  }, [mail]);

  useEffect(() => {
    const { documento, credit_id } = creditUser || {};
    if (documento || credit_id) {
      mergeSentryUser({ username: documento || undefined, id: credit_id || undefined });
    }
  }, [creditUser?.documento, creditUser?.credit_id]);

  return null;
};

export default SentryUserSync;
